/* Utility class to play sound effects */

import React from "react";

import chatAudio from './assets/chat-line.mp3';

/*import UIfx from 'uifx'

// import the wave resources
import chatAudio from './assets/chat-fx2.mp3'
import storyAudio from './assets/chat-fx1.mp3'

// HACK: remove this and make it a configurable Global Setting
const AUDIO_ENABLED = window.location.href.indexOf("audio-on") !== -1;

const chatPlayer = AUDIO_ENABLED ? new UIfx(chatAudio) : null;
const storyPlayer = AUDIO_ENABLED ? new UIfx(storyAudio) : null;

// NOTE: the new logic will integrate 'up to' timeout milliseconds later; the previous implementation kept
//       pushing the boundary timeoutMs ahead
function playSoundCoalesced(player, timeoutMs) {
  if (!AUDIO_ENABLED) return;
  if (player.hasOwnProperty('coalesceTimer')) return; // clearTimeout(player.coalesceTimer);
  player.coalesceTimer = setTimeout(() => {
    player.play();
    delete player.coalesceTimer;
  }, timeoutMs)
}

export const playMessageSound = () => playSoundCoalesced(chatPlayer, 100);
export const playStorySound = () => playSoundCoalesced(storyPlayer, 100);
*/


export const playMessageSound = () => <audio src={chatAudio} autoPlay/>;
// export const playStorySound = () => null;
